<script>
	const utilities = require('utilities');
	module.exports = {
		props: ['article', 'assessment', 'orderedStudents', 'assignmentId'],
		components: {
			'word-detective': require('components/word-detective.vue').default,
			'meaning-mapper': require('components/meaning-mapper.vue').default,
			'graphic-organizer-key-modal': require('components/graphic-organizer-key-modal.vue').default,
			'key-icon': require('components/svg/key-icon.vue').default
		},
		modelData: ['student'],
		data() {
			return {
				selectedStudent: null,
				currentStudentIdx: 0,
				view: 'teacher'
			};
		},
		computed: {
			aid() {
				let assignmentId = this.assignmentId;
				let view = this.view;
				let id = null;
				if (view === 'teacher' && assignmentId) {
					id = assignmentId;
				}
				return id;
			},
			organizerComponent() {
				let component = null;
				let assessment = this.assessment;

				if (assessment && assessment.options) {
					if (assessment.options.wd) {
						component = 'word-detective';
					}
					if (assessment.options.mm) {
						component = 'meaning-mapper';
					}
				}
				return component;
			},
			organizerData() {
				let selectedStudent = this.selectedStudent;
				let view = this.view;
				let data = null;

				if (view !== 'teacher' && selectedStudent && selectedStudent.graphicOrganizer) {
					data = this.getOrganizer(selectedStudent);
				}
				return data;
			}
		},
		methods: {
			selectStudent(student) {
				let orderedStudents = this.orderedStudents;
				this.selectedStudent = student;
				orderedStudents.some((s, idx) => {
					if (s.uid === student.uid) {
						this.currentStudentIdx = idx;
						return true;
					}
					return false;
				});
			},
			onNextStudentClick() {
				let idx = this.currentStudentIdx;
				let orderedStudents = this.orderedStudents;
				let student = orderedStudents[0];
				if (idx < orderedStudents.length - 1) {
					student = orderedStudents[idx + 1];
				}
				this.selectStudent(student);
			},
			onPreviousStudentClick() {
				let idx = this.currentStudentIdx;
				let orderedStudents = this.orderedStudents;
				let student = orderedStudents[orderedStudents.length - 1];
				if (idx > 0) {
					student = orderedStudents[idx - 1];
				}
				this.selectStudent(student);
			},
			getEntryCount(student) {
				let count = 0;
				if (student && student.graphicOrganizer && student.graphicOrganizer.n) {
					let nodeCount = Object.keys(student.graphicOrganizer.n).length;
					count = nodeCount > 1 ? nodeCount - 1 : 0;
				}
				return '(' + count + ')';
			},
			getOrganizer(student) {
				let org = null;
				if (student && student.graphicOrganizer) {
					let nodes = Object.keys(student.graphicOrganizer.n).map(id => {
						let node = student.graphicOrganizer.n[id];
						return {
							id,
							root: !node.p,
							word: node.w,
							parentId: node.p,
							linkText: node.l,
							text: node.t
						};
					});
					org = {
						nodes
					};
				}
				return org;
			},
			onKeyClick() {
				utilities.openModal('#modal-graphic-organizer-key');
			}
		},
		created() {
			let orderedStudents = this.orderedStudents;
			if (orderedStudents && orderedStudents.length) {
				if (this.student) {
					this.view = 'students';
					orderedStudents.some(s => {
						if (s.uid === this.student) {
							this.selectStudent(s);
							return true;
						}
						return false;
					});
				} else {
					this.selectStudent(orderedStudents[0]);
				}
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.graphic-organizer-results {
		.toolbar {
			display: flex;
			align-items: center;

			.toggle-buttons {
				margin-right: 1rem;
				flex-basis: 15rem;
				min-width: 15rem;

				.toggle-button {
					flex: 1;
				}
			}

			.graphic-organizer-results-header {
				flex: 1;
				display: flex;
				align-items: center;
				margin: 0.5rem 0;

				.student-name {
					font-size: 1.5rem;
					flex: 1;
				}

				.student-picker {
					display: flex;
					align-items: center;
					font-size: 1.5rem;
					padding-right: 1rem;
					line-height: 1rem;

					.picker-body {
						padding: 0 0.5rem;
					}

					.picker-arrow {
						cursor: pointer;
						padding: 0 0.25rem;

						.fa {
							color: $c-blue;
							font-weight: bold;
							font-size: 2rem;
						}
					}
				}
			}
		}

		.content-body {
			display: flex;

			.student-selector {
				display: flex;
				flex-direction: column;
				flex-basis: 15rem;
				width: 15rem;
				margin-right: 1rem;

				.student {
					display: block;
					padding: 0.5rem 1rem;
					border: 1px solid $c-grey;
					background-color: $c-white;
					color: $c-blue;
					border-right-color: transparent;
					border-left-color: transparent;
					text-overflow: ellipsis;
					overflow: hidden;
					white-space: nowrap;

					&.selected {
						color: $c-blue;
						border-color: $c-slate;
						background-color: $c-grey-light;
						border-right-color: transparent;
						border-left-color: transparent;
					}
				}
			}

			.graphic-organizer-container {
				flex: 1;
				// border: 1px solid $c-slate;
				border-left-color: transparent;
				min-height: 600px;
				flex-basis: 400px;
				min-width: 400px;

				.word-bank {
					display: none;
				}

				.no-data {
					display: flex;
					align-items: center;
					justify-content: center;
					height: 100%;
				}
			}
		}

		&.individual-results {
			.student-selector,
			.student-name-inner,
			.toggle-buttons,
			.key-button {
				display: none;
			}

			.graphic-organizer-results-header .student-picker {
				display: none;
			}
		}

		&.teacher {
			.student-selector,
			.student-name-inner {
				display: none;
			}

			.content-body .graphic-organizer-container {
				.word-bank {
					display: inherit;
				}
			}

			.graphic-organizer-results-header .student-picker {
				display: none;
			}
		}
	}

	.whiteboard-view {
		.assessment {
			.main-header {
				.main-header-meta,
				.main-header-nav,
				.toggle-buttons {
					display: none;
				}

				.main-header-title {
					margin-bottom: 1rem;
				}
			}

			.graphic-organizer-results {
				.student-selector {
					display: none;
				}
			}
		}
	}
</style>
<template>
	<div
		class="main-content wrapper graphic-organizer-results"
		:class="{
			'individual-results': this.student,
			students: view === 'students',
			teacher: view === 'teacher'
		}">
		<div class="toolbar">
			<div class="toggle-buttons">
				<button
					class="toggle-button button"
					@click="view = 'teacher'"
					:class="{
						active: view === 'teacher'
					}"
					data-text="Teacher">
					Teacher
				</button>
				<button
					class="toggle-button button"
					@click="view = 'students'"
					:class="{
						active: view === 'students'
					}"
					data-text="Students">
					Students
				</button>
			</div>
			<div class="graphic-organizer-results-header">
				<div class="student-name">
					<span class="student-name-inner">{{ selectedStudent.firstName }} {{ selectedStudent.lastName || '' }}</span>
				</div>
				<div class="student-picker">
					<span
						class="picker-arrow previous"
						@click="onPreviousStudentClick"
						aria-label="Previous student">
						<i
							class="fa-solid fa-angle-left"
							aria-hidden="true"></i>
					</span>
					<span class="picker-body">{{ currentStudentIdx + 1 }} / {{ orderedStudents.length }}</span>
					<span
						class="picker-arrow next"
						@click="onNextStudentClick"
						aria-label="Next student">
						<i
							class="fa-solid fa-angle-right"
							aria-hidden="true"></i>
					</span>
				</div>
				<div class="tools">
					<button
						v-if="view === 'teacher'"
						class="key-button button"
						v-tooltip="'Teacher Key'"
						@click="onKeyClick">
						<key-icon></key-icon>
					</button>
				</div>
			</div>
		</div>
		<div class="content-body">
			<div class="student-selector">
				<button
					v-for="student in orderedStudents"
					:key="student.uid"
					class="student link"
					:class="{
						selected: selectedStudent.uid === student.uid
					}"
					:title="student.firstName + (student.lastName ? ' ' + student.lastName : '') + ' ' + getEntryCount(student)"
					@click="selectStudent(student)">
					{{ student.firstName }} {{ student.lastName || '' }} {{ getEntryCount(student) }}
				</button>
			</div>
			<div class="graphic-organizer-container">
				<component
					v-if="organizerData"
					:is="organizerComponent"
					:product="article"
					:organizer-data.sync="organizerData"
					:assignment-options="assessment.options"
					key="organizer-data-results"></component>
				<component
					v-if="aid"
					:is="organizerComponent"
					:aid="aid"
					:product="article"
					:teacher="view === 'teacher'"
					:assignment-options="assessment.options"
					key="aid-results"></component>
				<div
					class="no-data"
					v-if="!organizerData && !aid">
					This student has no Graphic Organizer data.
				</div>
			</div>
		</div>
		<graphic-organizer-key-modal :product="article"></graphic-organizer-key-modal>
	</div>
</template>
